import { WorkerMonthlyAttendanceDailyData } from '@/entity/WorkerMonthlyAttendanceDailyData';
import { WorkerMonthlyAttendanceSumData } from '@/entity/WorkerMonthlyAttendanceSumData';
import { workerMonthAttendanceDayList } from '@/constants/workerMonthlyAttendance/workerMonthlyAttendanceDayList';
import brgI18n from '@/locales';
import { convertCase, validateTextWithHypen, } from '@/utils';
export class WorkerMonthlyAttendance {
    _workerMonthlyAttendance;
    constructor(workerMonthlyAttendance) {
        this._workerMonthlyAttendance = workerMonthlyAttendance;
    }
    /** 허브명 */
    get formattedHubName() {
        return this._workerMonthlyAttendance.hubName;
    }
    /** 고용형태 */
    get formattedEmployeeType() {
        const employeeType = convertCase(this._workerMonthlyAttendance.employeeType, 'enum', 'snake');
        const employeeTypeText = brgI18n.global.t(`resource.worker.employee_type_option.${employeeType}`);
        return validateTextWithHypen(employeeTypeText);
    }
    /** 보수지급방식 */
    get formattedSalaryType() {
        const salaryType = convertCase(this._workerMonthlyAttendance.salaryType, 'enum', 'snake');
        const salaryTypeText = brgI18n.global.t(`resource.worker.salary_type_option.${salaryType}`);
        return validateTextWithHypen(salaryTypeText);
    }
    /** 라이더사번 */
    get formattedHubEmployeeNumber() {
        const { hubEmployeeNumber } = this._workerMonthlyAttendance;
        return validateTextWithHypen(hubEmployeeNumber);
    }
    /** 라이더명 */
    get formattedWorkerName() {
        const { workerName } = this._workerMonthlyAttendance;
        return validateTextWithHypen(workerName);
    }
    /** 합계 */
    get sumData() {
        return new WorkerMonthlyAttendanceSumData(this._workerMonthlyAttendance.sum);
    }
    /** 일별 데이터 */
    get dailyData() {
        const dailyData = [];
        workerMonthAttendanceDayList.forEach((value) => {
            dailyData.push(new WorkerMonthlyAttendanceDailyData(this._workerMonthlyAttendance[value]));
        });
        return dailyData;
    }
}
